export default {
    list: [{
            id: 1,
            name: 'components.shop.tabs.popular',
            icon: 'fal fa-star',
            category: 'popular',
            route: {
                name: 'client.shop.popular',
                params: {
                    page: 1,
                    id: undefined,
                }
            },
        },
        {
            id: 2,
            name: 'components.shop.tabs.pet',
            icon: 'fal fa-paw-claws',
            category: 'pet',
            route: {
                name: 'client.shop.pet',
                params: {
                    page: 1,
                    id: undefined,
                }
            },
        },
        {
            id: 3,
            name: 'components.shop.tabs.char',
            icon: 'fal fa-swords',
            category: 'char',
            route: {
                name: 'client.shop.char',
                params: {
                    page: 1,
                    id: undefined,
                }
            },
        },
        {
            id: 4,
            name: 'components.shop.tabs.misc',
            icon: 'fal fa-flask-potion',
            category: 'misc',
            route: {
                name: 'client.shop.misc',
                params: {
                    page: 1,
                    id: undefined,
                }
            },
        },
        {
            id: 5,
            name: 'components.shop.tabs.limited',
            icon: 'fal fa-alarm-snooze',
            category: 'limited',
            route: {
                name: 'client.shop.limited',
                params: {
                    page: 1,
                    id: undefined,
                }
            },
        },
        {
            id: 6,
            name: 'components.shop.tabs.discount',
            icon: 'fal fa-fire',
            category: 'discount',
            route: {
                name: 'client.shop.discount',
                params: {
                    page: 1,
                    id: undefined,
                }
            },
        },
    ]
}
